export const menuItems = [
    {
        id: 1,
        label: "menuitems.menu.text",
        isTitle: true,
        subadmin_module_id: null,
    },
    {
        id: 2,
        label: "menuitems.dashboard.text",
        link: "/",
        icon: "bx-home-circle",
        subadmin_module_id: 1,
    },

    {
        id: 5,
        label: "menuitems.patients.text",
        link: "/patients",
        icon: "bxs-user-rectangle",
        subadmin_module_id: 2,
    },

    {
        id: 8,
        label: "menuitems.consultations.text",
        link: "/consultations",
        icon: "bxs-calendar-event",
        subadmin_module_id: 3,
    },
    //  {
    //     id: 8,
    //     label: "menuitems.consultations.text",
    //     link: "",
    //     icon: "bxs-capsule",

    //     subItems: [
    //         {
    //             id: 14,
    //             label: "menuitems.consultations.list.consultation",
    //             link: "/consultations",
    //             parentId: 8
    //         },
    //         {
    //             id: 15,
    //             label: "menuitems.consultations.list.clinic",
    //             link: "/clinic-bookings",
    //             parentId: 8
    //         },]
    //     },


    // {
    //     id: 9,
    //     label: "menuitems.doctors.text",
    //     link: "/doctors",
    //     icon: "bxs-calendar-event",
    // },

    {
        id: 9,
        label: "menuitems.doctors.text",
        link: "",
        icon: "bx-plus-medical",
        subadmin_module_id: 4,

        subItems: [
            {
                id: 10,
                label: "menuitems.doctors.list.scheduled",
                link: "/doctors",
                parentId: 9
            },
            {
                id: 11,
                label: "menuitems.doctors.list.unscheduled",
                link: "/doctors/pending",
                parentId: 9
            },
            // {
            //     id: 12,
            //     label: "menuitems.doctors.list.token_manage",
            //     link: "/doctors/tokens",
            //     parentId: 9
            // },
        ]
    },

    {
        id: 30,
        label: "menuitems.pharmacy.text",
        link: "/pharmacies",
        icon: "bxs-capsule",
        subadmin_module_id: 12,
    },

    {
        id: 31,
        label: "menuitems.labs.text",
        link: "",
        icon: "bx-clinic",
        subItems: [
            {
                id: 32,
                label: "menuitems.labs.list.labs",
                link: "/labs",
                parentId: 31
            },
            {
                id: 33,
                label: "menuitems.labs.list.tests",
                link: "/tests",
                parentId: 31
            },
        ]
    },

    {
        id: 17,
        label: "menuitems.token.text",
        link: "/doctors/tokens",
        icon: "bx-plus-medical",
        subadmin_module_id: 5,
    },
    {
        id: 18,
        label: "menuitems.prescriptions.text",
        link: "/prescriptions",
        icon: "bxs-calendar-event",
        subadmin_module_id: 6,
    },


    // {
    //     id: 13,
    //     label: "menuitems.specializations.text",
    //     link: "/specializations",
    //     icon: "bx-book",
    // },    

    // {
    //     id: 17,
    //     label: "menuitems.sliders.text",
    //     link: "/sliders",
    //     icon: "bx-slider-alt",
    // },    

    // {
    //     id: 19,
    //     label: "menuitems.languages.text",
    //     link: "/languages",
    //     icon: "bx-user-voice",
    // },

    // {
    //     id: 20,
    //     label: "menuitems.deliverystaffs.text",
    //     link: "/delivery-staffs",
    //     icon: "bxs-cart",
    // }, 

    // {
    //     id: 21,
    //     label: "menuitems.marketingstaffs.text",
    //     link: "/marketing-staffs",
    //     icon: "bx-briefcase",
    // }, 

    // {
    //     id: 22,
    //     label: "menuitems.clinics.text",
    //     link: "/clinics",
    //     icon: "bx-clinic",
    // },

    {
        id: 23,
        label: "menuitems.tvshows.text",
        link: "/tvshows",
        icon: "bx-tv",
        subadmin_module_id: 7,
    },

    {
        id: 24,
        label: "menuitems.scrollcontents.text",
        link: "/scroll-contents",
        icon: "bx-book-content",
        subadmin_module_id: 8,
    },
    {
        id: 25,
        label: "menuitems.reports.text",
        link: "",
        icon: "bx-file",
        subadmin_module_id: 9,

        subItems: [
            {
                id: 26,
                label: "menuitems.reports.list.patient",
                link: "/reports/patients",
                parentId: 25
            },
            {
                id: 27,
                label: "menuitems.reports.list.consultation",
                link: "/reports/consultations",
                parentId: 25
            },
            {
                id: 28,
                label: "menuitems.reports.list.earning",
                link: "/reports/earnings",
                parentId: 25
            },

        ]
    },

    // {
    //     id: 25,
    //     label: "menuitems.feedbacks.text",
    //     link: "/feedbacks",
    //     icon: "bx-message-dots",
    // },

    // {
    //     id: 26,
    //     label: "menuitems.faqs.text",
    //     link: "/faqs",
    //     icon: "bx-question-mark",
    // },

    {
        id: 27,
        label: "menuitems.notifications.text",
        link: "/notifications",
        icon: "bx-bell",
        subadmin_module_id: 10,
    },

    {
        id: 29,
        label: "menuitems.settings.text",
        link: "/settings",
        icon: "bx-cog",
        subadmin_module_id: 11,
    },
];

